import * as React from "react";

export type AlertTitleProps = React.HTMLAttributes<HTMLSpanElement>

export default function AlertTitle(props: AlertTitleProps): JSX.Element {
  const { children, className = "", ...other } = props;

  return (
    <span
      className={`block font-semibold mb-1 ${className}`}
      {...other}
    >
      {children}
    </span>
  );
}